import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header style={{ background: '#fff', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', padding: '1rem 0' }}>
      <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Link to="/" style={{ fontSize: '24px', fontWeight: 'bold', textDecoration: 'none', color: '#007bff' }}>
          Rental Property Management
        </Link>
        <nav style={{ display: 'flex', gap: '2rem' }}>
          <Link to="/" style={{ textDecoration: 'none', color: '#333' }}>Home</Link>
          <Link to="/pricing" style={{ textDecoration: 'none', color: '#333' }}>Pricing</Link>
          <Link to="/contact" style={{ textDecoration: 'none', color: '#333' }}>Contact Us</Link>
          <Link to="/login" style={{ textDecoration: 'none', color: '#333' }}>Login</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;